import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import type { PortalSubscriptionData } from '@/types/api';

/** Read-only list of the client's current services/retainers. */
export function usePortalSubscriptions() {
  return useQuery({
    queryKey: ['portal-subscriptions'],
    queryFn: async (): Promise<PortalSubscriptionData[]> => {
      const { data } = await api.get<PortalSubscriptionData[]>('/v1/portal/subscriptions');
      return data;
    },
  });
}
